import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CForm,
  CFormInput,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilTrash, cilPencil, cilPlus, cilCheck, cilX } from '@coreui/icons'
import swal from 'sweetalert'
import {
  getDeliveryBoys,
  deleteDeliveryBoy,
  addDeliveryBoy,
  updateDeliveryBoy,
} from 'src/redux/deliveryboys'

const DeliveryBoys = () => {
  const dispatch = useDispatch()
  const { deliveryBoys } = useSelector((state) => state.deliveryboys)

  const [visible, setVisible] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [editId, setEditId] = useState(null)

  const [form, setForm] = useState({
    name: '',
    username: '',
    password: '',
    mobile_no: '',
    email_id: '',
  })

  useEffect(() => {
    dispatch(getDeliveryBoys())
  }, [dispatch])

  const handleDelete = (id) => {
    swal({
      title: 'Are you sure?',
      text: 'You want to delete this delivery boy?',
      icon: 'warning',
      buttons: ['No', 'Yes, delete it!'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(deleteDeliveryBoy(id))
      }
    })
  }

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (isEditMode) {
      dispatch(updateDeliveryBoy(editId, form)).then(() => {
        resetForm()
      })
    } else {
      dispatch(addDeliveryBoy(form)).then(() => {
        resetForm()
      })
    }
  }

  const resetForm = () => {
    setForm({
      name: '',
      username: '',
      password: '',
      mobile_no: '',
      email_id: '',
    })
    setVisible(false)
    setIsEditMode(false)
    setEditId(null)
  }

  const openEditModal = (boy) => {
    setIsEditMode(true)
    setEditId(boy.id)
    setForm({
      name: boy.name,
      username: boy.username,
      password: boy.password,
      mobile_no: boy.mobile_no,
      email_id: boy.email_id,
    })
    setVisible(true)
  }

  return (
    <div>
      <CTable striped hover responsive bordered>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell>#</CTableHeaderCell>
            <CTableHeaderCell>Name</CTableHeaderCell>
            <CTableHeaderCell>Username</CTableHeaderCell>
            <CTableHeaderCell className="text-center">Mobile</CTableHeaderCell>
            <CTableHeaderCell className="text-center">Mobile OTP</CTableHeaderCell>
            <CTableHeaderCell className="text-center">Email</CTableHeaderCell>
            <CTableHeaderCell className="text-center">Email OTP</CTableHeaderCell>
            <CTableHeaderCell className="text-center">Password</CTableHeaderCell>
            <CTableHeaderCell className="text-center">Status</CTableHeaderCell>
            <CTableHeaderCell className="text-center">
              <CButton size="sm" color="primary" onClick={() => setVisible(true)}>
                <CIcon icon={cilPlus} className="me-2" />
                Add Delivery Boy
              </CButton>
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {deliveryBoys?.map((boy, index) => (
            <CTableRow key={boy.id}>
              <CTableHeaderCell>{index + 1}</CTableHeaderCell>
              <CTableDataCell>{boy.name}</CTableDataCell>
              <CTableDataCell>{boy.username}</CTableDataCell>
              <CTableDataCell className="text-center">
                {boy.mobile_no}{' '}
                {boy.mobile_verify === 1 ? (
                  <CIcon icon={cilCheck} className="text-success" />
                ) : (
                  <CIcon icon={cilX} className="text-danger" />
                )}
              </CTableDataCell>
              <CTableDataCell className="text-center">{boy.mobile_otp}</CTableDataCell>
              <CTableDataCell className="text-center">
                {boy.email_id}{' '}
                {boy.email_verify === 1 ? (
                  <CIcon icon={cilCheck} className="text-success" />
                ) : (
                  <CIcon icon={cilX} className="text-danger" />
                )}
              </CTableDataCell>
              <CTableDataCell className="text-center">{boy.email_otp}</CTableDataCell>
              <CTableDataCell className="text-center">{boy.password}</CTableDataCell>
              <CTableDataCell className="text-center">{boy.status}</CTableDataCell>
              <CTableDataCell className="text-center">
                <CButton color="info" size="sm" className="me-2" onClick={() => openEditModal(boy)}>
                  <CIcon icon={cilPencil} />
                </CButton>
                <CButton color="danger" size="sm" onClick={() => handleDelete(boy.id)}>
                  <CIcon icon={cilTrash} />
                </CButton>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>

      <CModal visible={visible} onClose={resetForm}>
        <CModalHeader>
          <CModalTitle>{isEditMode ? 'Update Delivery Boy' : 'Add Delivery Boy'}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CForm onSubmit={handleSubmit}>
            <CFormInput
              label="Name"
              name="name"
              value={form.name}
              onChange={handleInputChange}
              className="mb-2"
              required
            />
            <CFormInput
              label="Username"
              name="username"
              value={form.username}
              onChange={handleInputChange}
              className="mb-2"
              required
            />
            <CFormInput
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleInputChange}
              className="mb-2"
              required
            />
            <CFormInput
              label="Mobile Number"
              name="mobile_no"
              value={form.mobile_no}
              onChange={handleInputChange}
              className="mb-2"
              required
            />
            <CFormInput
              label="Email ID"
              name="email_id"
              type="email"
              value={form.email_id}
              onChange={handleInputChange}
              className="mb-3"
            />
            <CButton type="submit" color="success" className="w-100">
              {isEditMode ? 'Update' : 'Submit'}
            </CButton>
          </CForm>
        </CModalBody>
      </CModal>
    </div>
  )
}

export default DeliveryBoys
